import React from 'react';

import { StyledSpinner } from '../styles/StyledSpinner';

const Spinner = () => <StyledSpinner />

export default Spinner;